module.exports = __webpack_public_path__ + "static/media/img_feature_photo2@3x.631239ad.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_feature_photo2@3x.webp
// module id = 803
// module chunks = 0